import DispatchConstants from '../../constants/DispatchConstants';

const initState = () => ({
  users: [],
  isLoading: false,
  error: '',
});

const applicationPermissions = (state = initState(), action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case DispatchConstants.USER_MANAGEMENT_GET_APPLICATION_PERMISSIONS_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case DispatchConstants.USER_MANAGEMENT_GET_APPLICATION_PERMISSIONS_SUCCESS:
      return {
        ...state,
        users: payload.users,
        isLoading: false,
      };
    case DispatchConstants.USER_MANAGEMENT_GET_APPLICATION_PERMISSIONS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };
    default:
      return state;
  }
};

export default applicationPermissions;
